import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';

import { Flex } from 'components/layout';
import { Typography } from 'components/typography';

type TriggerLabelSectionProps = {
  label: string;
  open: boolean;
};

export function TriggerLabelSection({ label, open }: TriggerLabelSectionProps) {
  return (
    <Flex align='center' gap='sm' justify='between' className='w-full'>
      <Typography variant='body-xs' weight='semibold' textColor='muted'>
        {label}
      </Typography>
      {open ? (
        <ChevronUpIcon className='h-4 w-4' aria-hidden />
      ) : (
        <ChevronDownIcon className='h-4 w-4' aria-hidden />
      )}
    </Flex>
  );
}
